import { Children } from "react";

/** Medium-style article blocks for the IC case study */
export function ICArticleHeader({ title, dek, byline, simple = false }) {
  return (
    <header className={`ic-article__header ic-focus-block${simple ? " ic-article__header--simple" : ""}`.trim()}>
      <h1>{title}</h1>
      {dek ? <p className="ic-dek">{dek}</p> : null}
      {byline ? <p className="ic-byline">{byline}</p> : null}
    </header>
  );
}

/** Compact meta row under the hero (role, timeline, team). */
export function ICOverviewMeta({ items = [] }) {
  if (!items.length) return null;
  return (
    <dl className="ic-overview-meta ic-focus-block">
      {items.map(({ label, value }) => (
        <div key={label}>
          <dt>{label}</dt>
          <dd>{value}</dd>
        </div>
      ))}
    </dl>
  );
}

export function ICArticleBody({ children, className = "", focus = true }) {
  const content = focus
    ? Children.map(Children.toArray(children), (child, index) => (
        <div className="ic-focus-block" key={index}>
          {child}
        </div>
      ))
    : children;

  return <div className={`ic-article__body ${className}`.trim()}>{content}</div>;
}

export function ICH2({ children, id }) {
  return (
    <h2 id={id} className="ic-h2 ic-focus-block">
      {children}
    </h2>
  );
}

export function ICFigure({ src, alt, caption, bleed = false, screenHero = false, onZoom }) {
  const isVideo = /\/video\/upload\//.test(src) || /\.(mp4|webm|mov)(\?|$)/i.test(src);
  const className = [
    "ic-figure ic-focus-block",
    bleed ? "ic-figure--bleed" : "",
    screenHero ? "ic-figure--screen" : "",
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <figure className={className}>
      {isVideo ? (
        <video src={src} autoPlay muted loop playsInline aria-label={alt} />
      ) : (
        <img src={src} alt={alt} onClick={onZoom ? () => onZoom(src) : undefined} />
      )}
      {caption ? <figcaption>{caption}</figcaption> : null}
    </figure>
  );
}
